import React from 'react';

interface PageHeaderProps {
  title: string | React.ReactNode;
  subtitle?: string;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, badge, actions, className = '' }) => {
  return (
    <div className={`flex items-start sm:items-end justify-between mb-6 sm:mb-8 gap-3 sm:gap-4 flex-wrap ${className}`}>
      <div className="min-w-0 flex-1">
        {badge && <div className="mb-2 sm:mb-3">{badge}</div>}
        <h1 className="font-display text-xl sm:text-2xl lg:text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white">
          {title}
        </h1>
        {subtitle && <p className="text-slate-600 dark:text-slate-400 mt-1 text-xs sm:text-sm">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">{actions}</div>}
    </div>
  );
};
